import { AudioManager } from "../../AudioManager";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { Button } from "../../utils/Utils";
import { BoardManager } from "./BoardManager";

export class PauseLayer extends Phaser.GameObjects.Container {

    private container1: Phaser.GameObjects.Container;
    private audioOnButton: Button;
    private audioOffButton: Button;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        const tmpBackground = new Phaser.GameObjects.Graphics(this.scene);
        tmpBackground.fillStyle(0x153149);
        tmpBackground.fillRect(0, 0, GameConstants.GAME_HEIGHT, GameConstants.GAME_HEIGHT);
        tmpBackground.alpha = .5;
        this.add(tmpBackground);

        const scaledItemsContainer = new Phaser.GameObjects.Container(this.scene);
        scaledItemsContainer.x = GameConstants.GAME_WIDTH / 2;
        scaledItemsContainer.y = GameConstants.GAME_HEIGHT / 2;
        scaledItemsContainer.scaleY = GameVars.scaleY;
        this.add(scaledItemsContainer);

        const w = 390;
        const h = 320;

        const menuBackground = new Phaser.GameObjects.Graphics(this.scene);
        menuBackground.fillStyle(0x153149);
        menuBackground.fillRect(-w / 2, -h / 2 - 10, w, h);
        scaledItemsContainer.add(menuBackground);

        const upperFrame = new Phaser.GameObjects.Image(this.scene, 0, -170, "texture_atlas_2", "frame_top");
        scaledItemsContainer.add(upperFrame);

        const lowerFrame = new Phaser.GameObjects.Image(this.scene, 0, 150, "texture_atlas_2", "frame_bottom");
        scaledItemsContainer.add(lowerFrame);

        let leftFrame = new Phaser.GameObjects.Image(this.scene, -190, -90, "texture_atlas_2", "frame_border");
        scaledItemsContainer.add(leftFrame);
        leftFrame = new Phaser.GameObjects.Image(this.scene, -190, -90 + leftFrame.height, "texture_atlas_2", "frame_border");
        scaledItemsContainer.add(leftFrame);
        leftFrame = new Phaser.GameObjects.Image(this.scene, -190, -90 + 2 * leftFrame.height, "texture_atlas_2", "frame_border");
        scaledItemsContainer.add(leftFrame);

        let rightFrame = new Phaser.GameObjects.Image(this.scene, 192, -90, "texture_atlas_2", "frame_border");
        scaledItemsContainer.add(rightFrame);
        rightFrame = new Phaser.GameObjects.Image(this.scene, 192, -90 + rightFrame.height, "texture_atlas_2", "frame_border");
        scaledItemsContainer.add(rightFrame);
        rightFrame = new Phaser.GameObjects.Image(this.scene, 192, -90 + 2 * rightFrame.height, "texture_atlas_2", "frame_border");
        scaledItemsContainer.add(rightFrame);

        const menuTitle = new Phaser.GameObjects.Image(this.scene, 0, upperFrame.y - 15, "texture_atlas_3", "title_pause");
        scaledItemsContainer.add(menuTitle);

        this.container1 = new Phaser.GameObjects.Container(this.scene);
        scaledItemsContainer.add(this.container1);

        this.audioOnButton = new Button(this.scene, -90, -90, "texture_atlas_1", "btn_sound_on_off", "btn_sound_on_on");
        this.audioOnButton.onDown(this.onDownAudio, this);
        this.container1.add(this.audioOnButton);

        this.audioOffButton = new Button(this.scene, -90, -90, "texture_atlas_1", "btn_sound_off_off", "btn_sound_off_on");
        this.audioOffButton.onDown(this.onDownAudio, this);
        this.container1.add(this.audioOffButton);

        if (GameVars.gameData.muted) {
            this.audioOnButton.visible = false;
            this.audioOffButton.visible = true;
        } else {
            this.audioOnButton.visible = true;
            this.audioOffButton.visible = false;
        }

        const restartButton = new Button(this.scene, 0, 50, "texture_atlas_3", "btn_base_off", "btn_base_on");
        restartButton.onDown(this.onDownRestart, this);
        this.container1.add(restartButton);

        const restartLabel  = new Phaser.GameObjects.Image(this.scene, 0, restartButton.y, "texture_atlas_3", "text_restart");
        this.container1.add(restartLabel);

        const rulesButton = new Button(this.scene, 64, -90, "texture_atlas_1", "btn_rules_off", "btn_rules_on");
        rulesButton.onDown(this.onDownRules, this);
        this.container1.add(rulesButton);


        // EL BOTON DE CERRAR EL MENU
        const closeButton = new Button(this.scene, 190, -190, "texture_atlas_1", "btn_close_off", "btn_close_on");
        closeButton.onDown(this.onCloseMenu, this);
        scaledItemsContainer.add(closeButton);
        
        this.alpha = 0;
        
        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 350
        });
    }

    private onCloseMenu(): void {

        if (!this.scene) {
            return;
        }

        BoardManager.currentInstance.resumeGame();

        AudioManager.playSound("btn_feature_pressed");
    }

    private onDownAudio(): void {

        AudioManager.toggleAudioState();

        if (GameVars.gameData.muted) {
            this.audioOnButton.visible = false;
            this.audioOffButton.visible = true;
        } else {
            this.audioOnButton.visible = true;
            this.audioOffButton.visible = false;
        }

        AudioManager.playSound("btn_feature_pressed");
    }

    private onDownRestart(): void {

        BoardManager.currentInstance.forceGameOver();

        AudioManager.playSound("btn_feature_pressed");
    }

    private onDownRules(): void {

        BoardManager.currentInstance.showRules();

        AudioManager.playSound("btn_feature_pressed");
    }
}
